module.exports = __webpack_public_path__ + "static/img/26.03b7a469.gif";